// components/leads/DraggableLeadCard.js
// Wrapper per LeadCard con funzionalità drag & drop

import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';
import LeadCard from './LeadCard';

const DraggableLeadCard = ({ 
  lead, 
  isDragDisabled = false,
  ...cardProps 
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: lead.id,
    data: {
      type: 'lead',
      lead,
      status: lead.status,
    },
    disabled: isDragDisabled,
  });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    zIndex: isDragging ? 1000 : 'auto',
  };

  // Lead persi o convertiti non sono draggabili
  const isTerminalState = lead.status === 'perso' || lead.status === 'convertito';
  const canDrag = !isDragDisabled && !isTerminalState;

  return (
    <div 
      ref={setNodeRef} 
      style={style}
      className={`relative group ${isDragging ? 'shadow-xl ring-2 ring-[#FF7819]/50 rounded-xl' : ''}`}
    >
      {/* Drag Handle - visibile solo su hover e se può essere draggato */}
      {canDrag && (
        <div
          {...attributes}
          {...listeners}
          className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-1 z-10 
                     opacity-0 group-hover:opacity-100 transition-opacity cursor-grab active:cursor-grabbing
                     bg-white border border-gray-200 rounded-md p-1 shadow-sm hover:bg-gray-50"
          onClick={(e) => e.stopPropagation()}
          data-testid={`drag-handle-${lead.id}`}
        >
          <GripVertical className="w-4 h-4 text-gray-400" />
        </div>
      )}
      
      {/* LeadCard originale */}
      <LeadCard 
        lead={lead} 
        {...cardProps}
      />
    </div>
  );
};

export default DraggableLeadCard;
